import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { Steps, Row, Col, ColProps } from 'antd';

interface StepDefinition {
  title: React.ReactNode;
  content: React.ReactElement;
}

interface Props {
  contentWidth?: string;
  activeStep?: number;
  steps: StepDefinition[];
  stepsColProps?: ColProps;
}
const { Step } = Steps;

const StyledSteps = styled(Steps)`
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: ${({ theme }: { theme: DefaultTheme }) => theme.primaryColor};
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    font-weight: 500;
    color: ${({ theme }: { theme: DefaultTheme }) => theme.primaryColor};
  }
  .ant-steps-item-content {
    width: calc(100% - 25px);
  }
  .ant-steps-item-title {
    font-size: 14px;
    line-height: 23px;
    white-space: pre-wrap;
  }
  .ant-steps-item-title::after {
    display: none;
  }
  .ant-steps-item-icon {
    width: 21px;
    height: 21px;
    line-height: 21px;
    font-size: 12px;
  }
`;

const stepsColPropsDefault = { xl: { span: 24 }, lg: { span: 24 } };

const Wizard: React.FC<Props> = ({
  steps,
  activeStep,
  contentWidth = '540px',
  stepsColProps = stepsColPropsDefault,
}) => {
  const [currentStep, setCurrentStep] = React.useState(activeStep ?? 0);

  const [nextStep, setNextStep] = React.useState(
    activeStep ? activeStep + 1 : 1
  );

  const handleNextStep = () => {
    setCurrentStep((step) => step + 1);
    setNextStep(currentStep + 1);
  };
  const handlePrevStep = () => {
    setCurrentStep((step) => step - 1);
    setNextStep(currentStep - 1);
  };

  const currentContent = React.cloneElement(steps[currentStep].content, {
    currentStep,
    nextStep,
    onFinish: handleNextStep,
    goBack: handlePrevStep,
  });

  return (
    <Row>
      <Col xl={{ span: 18, offset: 3 }} lg={{ span: 24 }}>
        <Row className="titles-wrapper" css="margin-bottom: 40px">
          <Col {...stepsColProps}>
            <StyledSteps current={currentStep}>
              {steps.map((item) => (
                <Step key={item.title?.toString()} title={item.title} />
              ))}
            </StyledSteps>
          </Col>
        </Row>
        <Row justify="center">
          <Col flex={contentWidth}>{currentContent}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Wizard;
